import { Outlet, NavLink } from 'react-router-dom';
import { useAuth0 } from "@auth0/auth0-react";
import { Container } from '@mui/material';
import { AdminSidebar } from '../components/AdminSidebar';
import { FadeContainer } from '../../../components/FadeContainer';

export const Admin = () => {

  const { user } = useAuth0();

  return (
    <>
      <aside>
        <AdminSidebar />
      </aside>
      <FadeContainer component="main">
        <div className="gc_view">
          <Outlet />
        </div>
      </FadeContainer>
    </>
  );
}

